import React, { useState } from 'react';

import i18n from 'translation';

import { WithOptionsWidgetProps } from 'components/widgetParts/withOptionsWidget'
import TabbedDialog from 'components/dialogs/TabbedDialog';
import SettingsOptions from 'components/settingsConfig/SettingsOptions';
import SettingsColorPicker from 'components/settingsConfig/uiComponents/SettingsColorPicker';
import SplitSettingsWrapper from 'components/settingsConfig/SplitSettingsWrapper';
import { ColorBoxPreview } from './ColorBoxPreview';

export type ColorBoxSettingsStateType = {
  colorValue: string;
};

export const defaultSettings: ColorBoxSettingsStateType = {
  colorValue: ''
};

export default function ColorBoxSettings(props: WithOptionsWidgetProps): React.JSX.Element {
  const updateWidgetData = () => {
    if (props.widget?.id && props.onUpdateWidgetData) {
      props.onUpdateWidgetData(props.widget?.id, {
        settings: settingsState
      }).then(() => {
        if (props.widgetRefresh) {
          props.widgetRefresh();
        }
      })
    }
  }

  // Old settings were stored in the "data" object.
  // Using both widget.data & widget.data.settings provides backwards compatibility
  const [settingsState, setSettingsState] = useState<ColorBoxSettingsStateType>({
    ...defaultSettings,
    ...props?.widget?.data,
    ...props?.widget?.data?.settings,
  });
  const settingsOnChange = (updatedState: ColorBoxSettingsStateType) => setSettingsState(updatedState);

  const [tabValue, setTabValue] = useState<number>(0);
  const handleTabChange = (event: React.SyntheticEvent<Element, Event>, newValue: number) => setTabValue(newValue);

  return (
    <TabbedDialog
      currentTab={tabValue}
      handleTabChange={handleTabChange}
      onCancel={() => { props.setSettingsDialogIsOpen(false);}}
      onConfirm={() => {
        updateWidgetData();
        props.setSettingsDialogIsOpen(false);
      }}
      open={true}
      tabs={[i18n.t("display")]}
      title={i18n.t("widget-types.color-box.settings.title")}>
      <SplitSettingsWrapper>
        <ColorBoxPreview settingsState={settingsState} />
        <SettingsOptions onChange={settingsOnChange} settingsState={settingsState}>
          <SettingsColorPicker
            keyid='colorValue'
            label={i18n.t("background-color")}
            color={settingsState.colorValue} />
        </SettingsOptions>
      </SplitSettingsWrapper>
    </TabbedDialog>
  );
}